import "ethers";
import colors from 'tailwindcss/colors';
// block explorer base path
export const BLOCK_EXPLORER_TRANSACTION = 'https://explorer-mumbai.maticvigil.com/tx/';
export const BLOCK_EXPLORER_ADDRESS = 'https://explorer-mumbai.maticvigil.com/address/';
// chain
export const CHAIN_ID = 80001; // mumbai
export const NETWORK_NAME = "Mumbai";
// covalent api key
export const COVALENT_KEY = 'ckey_7e3942e77eb947f7ab1ad48a3ca';
export const PAGE_LENGTH = 999999; // historical log pagination - number of blocks
export const logo = "./images/horsegen/horsegen-logo.svg";
export const logoReversed = "./images/horsegen/horsegen-logo-reversed.svg";
export const favicon = "./images/horsegen/favicon.png";
export const webclip = "./images/horsegen/webclip.png";
export const siteName = "Horsegen";
export const siteSub = "Tokenized horses";
export const curationContent = './curation/horse.json';
// theme for tailwind
export const theme = {
    extend: {
        colors: {
            primary: { ...colors.blue }
        }
    }
};
